import { render, staticRenderFns } from "./Locations.vue?vue&type=template&id=4281dd9c&scoped=true&"
import script from "./Locations.vue?vue&type=script&lang=js&"
export * from "./Locations.vue?vue&type=script&lang=js&"
import style0 from "./Locations.vue?vue&type=style&index=0&id=4281dd9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4281dd9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VCol,VDataTable,VRow,VTextField})
